module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAXCAYAAAA/ZK6/AAABCUlEQVQ4T43TTU7EMAwF4OdcjOPEYYEQ4mdmEEIC0QLSLNAsYrOYO3ANJM7ATWKUKh0N0KTNsnpfHKcOici3me1DCI9YsEhEOiJam9k9Mz/MGcoBVX0BcJ1S6kIIty00gIJ6AKs5dAAZxRifnHMbAK/e+5upSr9AqZT7uKuhfyAjEVkTUQdg672/PK40CVqoCsrxrvLRzOyNmc/ztyaYQrOgHO+CiLYAnheBUukDwMkiICJDBTPrZ4Gqjo3vmPls0S2llGII4bR5S+PPOw5XQS08CVR1mKW/O4/jMTmtZvbOzL45reMjKmEGYFWwNDz0EGPsnXOr/FK996G286EHVf0ys09mzuHZ9QPCH6Bznz9e+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/next.png
// module id = lum/
// module chunks = 0